export default {
    site_is_deactivated: "Diese Buchungsseite ist zur Zeit deaktiviert 😥",
    site_is_deactivated_help: "Der Anbieter dieser Seite hat die Buchungen zurzeit deaktiviert. " +
        "Falls Sie der Meinung sind, dass dies ein Fehler ist, kontaktieren Sie bitte den Organisator:",
    not_found: "Diese Buchungsseite konnte leider nicht gefunden werden 😥",
    not_found_help: "Falls Sie meinen, dass dies ein Fehler ist, kontaktieren Sie bitte den Organisator.",

    server_error: "Das hätte nicht passieren dürfen!  😥",
    server_error_help: "Sie können gleich versuchen diese Buchungsseite erneut aufzurufen. " +
        "Vielleicht war das eben nur ein kurzer Schluckauf unseres Systems. " +
        "Falls das Problem jedoch weiterhin besteht, dann machen Sie doch bitte den Organisator auf dieses Problem aufmerksam.",

    errorWhileDonation: "Leider ist bei Ihrer Buchung ein Fehler aufgetreten. Bitte versuchen Sie es später erneut. " +
        "Falls dieser Fehler weiterhin besteht, melden Sie sich bitte beim Organisator.",

    paypalUnauthorized: "Es wurde die Zahlungsart 'PayPal' angegeben, jedoch konnte keine autorisierte PayPal Zahlung " +
        "zu Ihrer Buchung gefunden werden.",

    invalidPaymentType: "Bei der Erstellung Ihrer Zahlung ist aufgrund ungültiger Daten ein Fehler aufgetreten.",
    orderTotalError: "Die angeforderten Zahlungswerte stimmen nicht mit den übermittelten überein.",
    paypalError: "Die verwendete Zahlungsschnittstelle konnte nicht erreicht werden.",
    orderCreationError: "Die angegebenen Daten wurden von der Zahlungsschnittstelle nicht akzeptiert.",
    orderTotalMismatch: "Der angefragte Zahlungsbetrag stimmt nicht mit dem errechneten überein.",
    articlePriceMismatch: "Angefragte Preise enthalten inkorrekte Werte."
}
